import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchUserInfo, type FetchUserInfoParams } from '../../api/fetchers/userInfo/fetcher';

interface FetchUserInfoActionParams extends FetchUserInfoParams {
  essential: boolean;
}

export const fetchUserInfoAction = createAsyncThunk(
  'userInfo/fetchUserInfo',
  (params: FetchUserInfoActionParams, { getState }) => {
    const store: any = getState();
    const bonusCasinoConfigHide = store.config?.casinoConfig?.hideBonusBalance === true;
    const bonusPlayerConfigDisabled = store.config?.playerConfig?.compliance?.displayBonusBalance !== true;
    const bonusCasinoConfigDisabled = store.config?.casinoConfig?.showBonusBalance !== true;

    return fetchUserInfo({
      ...params,
      totalBalance: bonusCasinoConfigHide || (bonusCasinoConfigDisabled && bonusPlayerConfigDisabled),
    });
  }
);
